import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import { brand } from 'utils/designTokens';

/** Veg / highlight toggles — brand dark green when on, neutral when off */
export const themeSwitchSx = {
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: brand.primary,
      '&:hover': { backgroundColor: 'rgba(31, 91, 64, 0.08)' },
      '& + .MuiSwitch-track': {
        backgroundColor: brand.primary,
        opacity: 0.55
      }
    }
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    opacity: 1
  }
};

export default function ThemeSwitch({ sx, ...props }) {
  return <Switch {...props} sx={[themeSwitchSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} />;
}

ThemeSwitch.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
